<template>
<div class="chapter">
<div class="inner_page">
<p class="half-title" id="pagei">THE CHANNEL ISLANDS IN THE GREAT WAR</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?66725ac6